// extracted by mini-css-extract-plugin
export var permissionTable = "SetPage-module--permissionTable--CAsHd";